import { useState } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import api from '../api';

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [msg, setMsg] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async e => {
    e.preventDefault();
    setLoading(true); setError('');
    try {
      await api.post('/auth/reset-password', { token: params.get('token'), password });
      setMsg('Password reset! Redirecting...');
      setTimeout(() => navigate('/login'), 2000);
    } catch (err) {
      setError(err.response?.data?.error || 'Reset failed. Link may have expired.');
    } finally { setLoading(false); }
  };

  const s = {
    wrap: { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f5f5f7' },
    card: { background: '#fff', borderRadius: 12, padding: '40px 36px', width: 360, boxShadow: '0 2px 16px rgba(0,0,0,0.08)' },
    title: { fontSize: 18, fontWeight: 600, marginBottom: 8 },
    input: { width: '100%', padding: '9px 12px', border: '1px solid #ddd', borderRadius: 8, fontSize: 14, marginBottom: 16, boxSizing: 'border-box' },
    btn: { width: '100%', padding: 10, background: '#534AB7', color: '#fff', border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 500, cursor: 'pointer' },
    link: { display: 'block', textAlign: 'center', marginTop: 16, fontSize: 13, color: '#534AB7', textDecoration: 'none' },
    success: { background: '#EAF3DE', color: '#27500A', padding: '10px 12px', borderRadius: 8, fontSize: 13, marginBottom: 16 },
    error: { background: '#FCEBEB', color: '#791F1F', padding: '10px 12px', borderRadius: 8, fontSize: 13, marginBottom: 16 },
  };

  return (
    <div style={s.wrap}>
      <div style={s.card}>
        <div style={s.title}>Set new password</div>
        {msg && <div style={s.success}>{msg}</div>}
        {error && <div style={s.error}>{error}</div>}
        {!msg && (
          <form onSubmit={submit}>
            <input style={s.input} type="password" placeholder="New password (min 8 chars)"
              value={password} onChange={e => setPassword(e.target.value)} minLength={8} required />
            <button style={s.btn} type="submit" disabled={loading}>{loading ? 'Saving...' : 'Reset password'}</button>
          </form>
        )}
        <Link to="/login" style={s.link}>Back to login</Link>
      </div>
    </div>
  );
}
